import React from 'react';
import { CheckContrastTool } from './CheckContrastTool';
import { GenerateScaleTool } from './GenerateScaleTool';
import { InstallPluginTool } from './InstallPluginTool';
import { isWebMCPSupported } from './webmcpSupported';
import { LeonardoUrlTool } from './LeonardoUrlTool';

/**
 * Registers core Color Scales I/O WebMCP tools with the browser.
 * Renders nothing; tools are discoverable via document.modelContext.
 */
export const WebMCPProvider: React.FC = () => {
  if (!isWebMCPSupported()) {
    return null;
  }

  return (
    <>
      <CheckContrastTool />
      <GenerateScaleTool />
      <LeonardoUrlTool />
      <InstallPluginTool />
    </>
  );
};
